var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkItemWrapper",style:(_vm.style.flex)},[_c('img',{staticClass:"checkButton",attrs:{"src":_vm.checkBoxImg},on:{"click":_vm.onCheckButton}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db2d845e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/elements/checkItemDuplicate.vue
// module id = null
// module chunks = 